import { capitalize } from "lodash"

export default null

/**
 * Return the titleized version of a string like in rails
 *
 * @param {*} str underscored string like_this
 * @returns titleized string
 */
export function titleize(str) {
    // this_is_some_text
    return str
        .split("_")
        .map((i) => capitalize(i))
        .join(" ")
}

/**
 * Format a number to display as currency e.g. 2500 -> $2,500.00
 *
 * @param {*} number number to display as currency
 * @param {*} empty  text to use if the number is empty e.g. n/a, or --, etc.
 * @returns formatted currency string
 */
export function currency(number, empty = "--") {
    // return the empty placeholder text if we get a NaN
    if (Number.isNaN(Number.parseFloat(number))) {
        return empty
    }

    const f = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" })
    return f.format(number)
}

/**
 * Format a byte count for display e.g. 1400000 -> 1.4 MB
 *
 * Decimal units (1 KB = 1000 bytes) to match Finder / the S3 console and the
 * decimal branch of the size parser in table-sort.js.
 *
 * @param {*} bytes raw byte count, e.g. ActiveStorage's blob byte_size
 * @param {*} empty text to use when the size is missing e.g. n/a, or --, etc.
 * @returns formatted size string
 */
export function fileSize(bytes, empty = "--") {
    const b = Number.parseFloat(bytes)

    if (Number.isNaN(b) || b < 0) {
        return empty
    }

    if (b < 1000) {
        return `${Math.round(b)} B`
    }

    const units = ["KB", "MB", "GB", "TB"]
    let value = b
    let i = -1

    // step up a unit at a time, stopping at TB so absurd values don't run off the end
    while (value >= 1000 && i < units.length - 1) {
        value = value / 1000
        i++
    }

    return `${new Intl.NumberFormat("en-US", { maximumFractionDigits: 1 }).format(value)} ${units[i]}`
}
